import { isEmpty, isNil, isValidNumber } from "@visactor/vutils";

export function autoLimit(labels, config) {
    const {limitLength: limitLength, verticalLimitLength: verticalLimitLength, ellipsis: ellipsis = "...", orient: orient, axisLength: axisLength} = config;
    if (isEmpty(labels) || !isValidNumber(limitLength)) return;
    const DELTA = Math.sin(Math.PI / 10);
    labels.forEach((label => {
        var _a;
        const angle = label.attribute.angle, hasAngle = !isNil(angle), cos = hasAngle ? Math.cos(angle) : 1, sin = hasAngle ? Math.sin(angle) : 0, isHorizontal = !hasAngle || Math.abs(sin) <= DELTA, isVertical = hasAngle && Math.abs(cos) <= DELTA, isX = "top" === orient || "bottom" === orient;
        if (isX) {
            if (isVertical && Math.floor(label.AABBBounds.height()) <= limitLength) return;
            if (isHorizontal && Math.floor(label.AABBBounds.width()) <= verticalLimitLength) return;
        }
        const direction = label.attribute.direction;
        if (!isX) {
            if ("vertical" === direction && Math.floor(label.AABBBounds.height()) <= verticalLimitLength) return;
            if ("vertical" !== direction) {
                if (isHorizontal && Math.floor(label.AABBBounds.width()) <= limitLength) return;
                if (isVertical && Math.floor(label.AABBBounds.height()) <= verticalLimitLength) return;
            }
        }
        let limitLabelLength = null;
        if (isHorizontal || isVertical) limitLabelLength = isX ? isHorizontal ? verticalLimitLength : limitLength : "vertical" === direction || isVertical ? verticalLimitLength : limitLength; else if (isX) {
            const {x1: x1, x2: x2} = label.AABBBounds, tan = sin / cos;
            limitLabelLength = tan > 0 && x1 <= axisLength && limitLength / tan + x1 > axisLength ? (axisLength - x1) / Math.abs(cos) : tan < 0 && x2 >= 0 && limitLength / tan + x2 < 0 ? x2 / Math.abs(cos) : Math.abs(limitLength / sin);
        } else limitLabelLength = Math.abs(limitLength / cos);
        isValidNumber(label.attribute.maxLineWidth) && (limitLabelLength = isValidNumber(limitLabelLength) ? Math.min(label.attribute.maxLineWidth, limitLabelLength) : label.attribute.maxLineWidth), 
        label.setAttributes({
            maxLineWidth: limitLabelLength,
            ellipsis: null !== (_a = label.attribute.ellipsis) && void 0 !== _a ? _a : ellipsis
        });
    }));
}
//# sourceMappingURL=auto-limit.js.map
